import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-50 bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-deep-forest/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="navbar-logo" className="flex items-center">
          <img src="/logos/logo_streetmow_tight.png" alt="StreetMow" className="h-16 w-auto object-contain" />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/" className={`hover:text-terracotta transition-colors ${location.pathname === "/" ? "text-terracotta" : "text-deep-forest"}`}>Home</Link>
          <Link to="/book" data-testid="nav-book-link" className="text-deep-forest hover:text-terracotta transition-colors">Get a quote</Link>
          {user && (
            <Link to="/dashboard" data-testid="nav-dashboard-link" className="text-deep-forest hover:text-terracotta transition-colors">Dashboard</Link>
          )}
          {user?.is_admin && (
            <Link to="/admin" data-testid="nav-admin-link" className="text-deep-forest hover:text-terracotta transition-colors flex items-center gap-1"><Shield className="w-4 h-4" /> Admin</Link>
          )}
        </div>

        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Link to="/login" data-testid="nav-login-btn" className="text-sm text-deep-forest hover:text-terracotta px-3 py-2">Log in</Link>
              <Link to="/register" data-testid="nav-register-btn" className="btn-primary text-sm">Sign up</Link>
            </>
          ) : (
            <>
              <span data-testid="nav-user-name" className="hidden sm:flex items-center gap-2 text-sm text-deep-forest/80">
                <User className="w-4 h-4" /> {user.name}
              </span>
              <button data-testid="nav-logout-btn" onClick={handleLogout} className="btn-secondary text-sm">
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
